import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Debt, Undertaking } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { BusinessDocumentTemplatesService } from '@repos/document-templates/business-document-templates.service';
import { DebtsState } from '@state/matter/debts';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { UndertakingsState } from '@state/matter/undertakings';
import { Observable } from 'rxjs';
import { ICON } from '@core/util/icon';
import { UndertakingDialogComponent } from './undertaking-dialog';
import { MatterWordDocumentsDefaultsSource } from '@state/matter/matter-word-documents/matter-word-documents-defaults-source.selectors';

@UntilDestroy()
@Component({
	selector: 'app-undertakings-given',
	templateUrl: './undertakings.component.html',
	styleUrls: ['./undertakings.component.scss'],
	standalone: false,
})
export class UndertakingsComponent implements OnInit {
	documentId: string;
	readonly ICON = ICON;
	@Select(SelectedMatter.useHtmlDocuments)
	public useHtmlDocuments$: Observable<boolean>;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(UndertakingsState.getAll) undertakings$: Observable<Undertaking[]>;
	@Select(DebtsState.getAll) debts$: Observable<Debt[]>;

	@Select(MatterWordDocumentsDefaultsSource.getUndertakingsSourceIdByMatterType)
	undertakingsDocSourceIdByMatterType$: Observable<string>;

	constructor(
		private businessDocumentTemplatesService: BusinessDocumentTemplatesService,
		private dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.undertakings$
			.pipe(untilDestroyed(this))
			.subscribe(() =>
				this.businessDocumentTemplatesService.triggerUpdate(
					this.documentId,
					this.matterId,
				),
			);

		this.debts$
			.pipe(untilDestroyed(this))
			.subscribe(() =>
				this.businessDocumentTemplatesService.triggerUpdate(
					this.documentId,
					this.matterId,
				),
			);
	}

	addUndertaking(): void {
		this.dialog.open(UndertakingDialogComponent, {
			autoFocus: true,
			data: {
				undertakingId: '',
				matterId: this.matterId,
			},
			maxHeight: '100%',
			maxWidth: '650px',
			minWidth: '300px',
			width: '50%',
		});
	}

	undertakingId(_, undertaking: Undertaking): string {
		return undertaking.id;
	}
}
